import { DialogTitle as MUIDialogTitle } from "@mui/material";
import { IBaseProps } from "../../../types/BaseProps";

export function DialogTitle({ children }: IBaseProps) {
  return <MUIDialogTitle>{children}</MUIDialogTitle>;
}
